import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import Store from "../Redux/Store";
import Routes from "./routes";

const { store, persistor } = Store();

const AppRoute = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Routes />
    </PersistGate>
  </Provider>
);

export default AppRoute;
